module.exports = __webpack_public_path__ + "img/StofernoCourier-OrangeBackground.80e35b76.png";